import React, {useEffect, useState} from "react";
import api from "../../api";
import IranFlag from "../../assets/images/iran.webp";
import {useParams} from "react-router-dom";
import LoadingSpinner from "../Loading";
import {toast, ToastContainer} from "react-toastify";
import {e2p} from "../../utils/utils";

function Album() {
    const [car, setCar] = useState(null);
    const [items, setItems] = useState(null);
    const [smoothingFullCost, setSmoothingFullCost] = useState(0);
    const [paintingFullCost, setPaintingFullCost] = useState(0);
    const [smoothingFullDuration, setSmoothingFullDuration] = useState(0);
    const [paintingFullDuration, setPaintingFullDuration] = useState(0);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [report, setReport] = useState(null);
    const [showTable, setShowTable] = useState(false);
    const [selectedDay, setSelectedDay] = useState(0);
    const [selectedColumn, setSelectedColumn] = useState(0);
    const [reservations, setReservations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleStatusChange = (event) => {
        setSelectedStatus(event.target.value);
        if (event.target.value === '2') {
            setShowTable(true)
        } else {
            setShowTable(false)
            setSelectedDay(0);
            setSelectedColumn(0);
        }
    };

    const [selectedReservation, setSelectedReservation] = useState(null);

    function handleCheckboxClick(dayIndex, columnIndex) {
        setSelectedReservation({dayIndex, columnIndex});
        handleCheckboxChange(dayIndex, columnIndex);
    }

    function handleCheckboxChange(day, column) {
        setSelectedDay(day);
        setSelectedColumn(column);
        console.log(day)
    }

    const handleSubmit = (event) => {
        setIsLoading(true);
        event.preventDefault();
        const requestBody = {
            'status': selectedStatus,
            'daysLater': selectedDay,
            'index': selectedColumn
        }
        api.post(`/repair-request/status/${requestId}`, requestBody)
            .then(res => {
                window.location.href = '/reports'
            })
            .catch(err => {
                toast.error(err.response);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const {carId} = useParams();
    const {requestId} = useParams();

    useEffect(() => {
        async function fetchData() {
            setIsLoading(true);
            try {
                const smoothingItemsPromise = api.get(`/repair-item/smoothing/${requestId}`);
                const paintingItemsPromise = api.get(`/repair-item/painting/${requestId}`);
                const carPromise = api.get(`/car/${carId}`);
                const reportPromise = api.get(`/repair-request/${requestId}`);
                const reservationsPromise = api.get(`/reservation`, {
                    params: {
                        'repair_request_id': requestId
                    }
                });

                const [smoothingItemsResponse, paintingItemsResponse, carResponse, reportResponse, reservationsResponse] = await Promise.all([
                    smoothingItemsPromise,
                    paintingItemsPromise,
                    carPromise,
                    reportPromise,
                    reservationsPromise
                ]);

                setItems(smoothingItemsResponse.data.data);
                setSmoothingFullCost(smoothingItemsResponse.data.fullCost);
                setSmoothingFullDuration(smoothingItemsResponse.data.totalDuration);

                setItems(paintingItemsResponse.data.data);
                setPaintingFullCost(paintingItemsResponse.data.fullCost);
                setPaintingFullDuration(paintingItemsResponse.data.totalDuration);

                setCar(carResponse.data.data);

                console.log(carResponse);

                setSelectedStatus(reportResponse.data.data.status.toString());
                if (reportResponse.data.data.status === 2) {
                    setShowTable(true);
                }
                setReport(reportResponse.data.data);

                setReservations(reservationsResponse.data.data);
                const reservationsData = reservationsResponse.data.data;
                reservationsData.forEach(rs => {
                    if (rs.changeable) {
                        const currentDate = new Date();
                        const differenceInMilliseconds = new Date(rs.date).getTime() - currentDate.getTime();
                        const dayIndex = Math.ceil(differenceInMilliseconds / (1000 * 60 * 60 * 24));
                        const columnIndex = rs.index;
                        setSelectedReservation({dayIndex, columnIndex});
                    }
                });

            } catch (error) {
                toast.error('مشکلی پیش آمده است. لطفا دوباره تلاش کنید.');
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }

        fetchData();
    }, []);


    return (
        <div>
            {isLoading ? <LoadingSpinner/> :
                <div className="content-wrapper">
                    <div className="container-xxl flex-grow-1 container-p-y">
                        
                        <div className="row justify-content-center g-0">
                            <div className="row w-auto pelak g-0 mb-3">
                                <div className="col">
                                    <div className="row my-auto">
                                        <div className="col border-start border-end-0">
                                            <p className="text-center fw-bold iranNo">ایران</p>
                                            <div>
                                                <p className="border-0 text-center">{car?.plate.slice(7, 9)}</p>
                                            </div>
                                        </div>
                                        <div className="col my-auto">
                                            <p className="border-0 text-center">{car?.plate.slice(3, 6)}</p>
                                        </div>
                                        <div className="col my-auto">
                                            <p className="border-0 text-center">{car?.plate.slice(2, 3)}</p>
                                        </div>
                                        <div className="col my-auto">
                                            <p className="border-0 text-center">{car?.plate.slice(0, 2)}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-auto leftSide">
                                    <div className="flag">
                                        <img src={IranFlag} alt="iran's flag"/>
                                    </div>
                                    <div className="iranText text-center">
                                        <p>I.R.</p>
                                        <p>IRAN</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
                                <div className="card rounded-4 border-2 border-dark mb-2">
                                    <h5 className="card-header text-center bg-dark text-white fw-bold">تعیین وضعیت</h5>
                                    <div className="card-body">
                                        <table className="table table-bordered">
                                            <thead>
                                            <tr>
                                                <th className="text-center">نوع تعمیر</th>
                                                <th className="text-center">زمان (روز)</th>
                                                <th className="text-center">مبلغ (تومان)</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td className="text-center">صافکاری</td>
                                                <td className="text-center">{e2p(smoothingFullDuration.toString())}</td>
                                                <td className="text-center">{e2p(smoothingFullCost?.toLocaleString()) ?? ''}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-center">نقاشی</td>
                                                <td className="text-center">{e2p(paintingFullDuration.toString())}</td>
                                                <td className="text-center">{e2p(paintingFullCost?.toLocaleString()) ?? ' '}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {report &&
                                    <div className="card mb-4">
                                        <h5 className="card-header">تعیین وضعیت</h5>
                                        <div className="card-body">
                                            <form onSubmit={handleSubmit}>
                                                <div className="form-check mb-3">
                                                    <input type="radio" id="paziresh" className="form-check-input"
                                                           name="status"
                                                           value="1" checked={selectedStatus === '1'}
                                                           onChange={handleStatusChange}
                                                           disabled={report.status === 3 || report.status === 4 || report.status === 5}
                                                    />
                                                    <label htmlFor="paziresh" className="form-check-label">پذیرش</label>
                                                </div>
                                                <div className="form-check mb-3">
                                                    <input type="radio" id="nobat" className="form-check-input"
                                                           name="status"
                                                           value="2" checked={selectedStatus === '2'}
                                                           onChange={handleStatusChange}
                                                           disabled={report.status === 3 || report.status === 4 || report.status === 1}
                                                    />
                                                    <label htmlFor="nobat" className="form-check-label">نوبت دهی</label>
                                                </div>
                                                <div className="form-check mb-3">
                                                    <input type="radio" id="painting" className="form-check-input"
                                                           name="status"
                                                           value="5" checked={selectedStatus === '5'}
                                                           onChange={handleStatusChange}
                                                           disabled={report.status === 4 || report.status === 3}
                                                    />
                                                    <label htmlFor="painting" className="form-check-label">نقاشی</label>
                                                </div>
                                                <div className="form-check mb-3">
                                                    <input type="radio" id="cancel" className="form-check-input"
                                                           name="status"
                                                           value="3" checked={selectedStatus === '3'}
                                                           onChange={handleStatusChange}/>
                                                    <label htmlFor="cancel" className="form-check-label">انصراف</label>
                                                </div>
                                                {showTable && (
                                                    <div className="card mb-4">
                                                        <div className="card-body">
                                                            <table className="table table-striped">
                                                                <thead>
                                                                <tr>
                                                                    <th>تاریخ</th>
                                                                    <th>رزرو ۱</th>
                                                                    <th>رزرو ۲</th>
                                                                    <th>رزرو ۳</th>
                                                                    <th>رزرو ۴</th>
                                                                    <th>رزرو ۵</th>
                                                                    <th>رزرو ۶</th>
                                                                    <th>رزرو ۷</th>
                                                                    <th>رزرو ۸</th>
                                                                    <th>رزرو ۹</th>
                                                                    <th>رزرو ۱۰</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {Array.from({length: 10}).map((_, dayIndex) => {
                                                                    const date = new Date();
                                                                    date.setDate(date.getDate() + dayIndex);
                                                                    const dateString = date.toLocaleDateString('fa-IR');
                                                                    const disabledIndices = reservations.filter(r => !r.changeable && r.date === date.toISOString().slice(0, 10)).map(r => r.index);
                                                                    return (
                                                                        <tr key={dateString}>
                                                                            <td>{dateString}</td>
                                                                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((columnIndex) => {
                                                                                const checked = selectedReservation && selectedReservation.dayIndex === dayIndex && selectedReservation.columnIndex === columnIndex;
                                                                                const disabled = disabledIndices.includes(columnIndex);
                                                                                return (
                                                                                    <td key={columnIndex}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={checked}
                                                                                            disabled={disabled}
                                                                                            onClick={() => handleCheckboxClick(dayIndex, columnIndex)}
                                                                                        />
                                                                                    </td>
                                                                                );
                                                                            })}
                                                                        </tr>
                                                                    );
                                                                })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="d-grid gap-2">
                                                    <button type="submit" className="btn btn-primary">ثبت</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Album
